import { render, staticRenderFns } from "./AppPieChart.vue?vue&type=template&id=1b8eda22&scoped=true&"
import script from "./AppPieChart.vue?vue&type=script&lang=js&"
export * from "./AppPieChart.vue?vue&type=script&lang=js&"
import style0 from "./AppPieChart.vue?vue&type=style&index=0&id=1b8eda22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b8eda22",
  null
  
)

export default component.exports